(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[136],{

/***/ 9828:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sklep/[...params]",
      function () {
        return __webpack_require__(9688);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dY": function() { return /* binding */ ImageTransformation; }
/* harmony export */ });
/* unused harmony exports Gallery, SingleGallery, Picture */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9496);
/* harmony import */ var _Picture_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6093);
/* harmony import */ var _Picture_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Picture_module_scss__WEBPACK_IMPORTED_MODULE_2__);

/* eslint-disable  @next/next/no-img-element */ 

function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {
        };
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var parseUrl = function(url) {
    var _url = url.split("/");
    return {
        baseUrl: _url.slice(0, _url.length - 1).join("/"),
        filename: _url[_url.length - 1]
    };
};
var ImageTransformation = function(url, param1) {
    var options = param1 === void 0 ? {
    } : param1;
    var src = parseUrl(url);
    if (src.baseUrl.substr(0, 4) !== "http") {
        src.baseUrl = "".concat("https://static.mellowly.eu").concat(src.baseUrl);
    }
    return "".concat(src.baseUrl).concat(Object.entries(options).map(function(param) {
        var _param = _slicedToArray(param, 2), k = _param[0], v = _param[1];
        return "/".concat(k, "=").concat(v);
    }).join(""), "/").concat(src.filename);
};
var Gallery = function(param) {
    var children = param.children;
    var count = React.Children.toArray(children).filter(function(child) {
        /*#__PURE__*/ return React.isValidElement(child);
    }).length;
    return(/*#__PURE__*/ _jsx("div", {
        className: "".concat(styles.gallery, " ").concat(styles["gallery-".concat(count)]),
        children: children
    }));
};
var SingleGallery = function(props) {
    return(/*#__PURE__*/ _jsx("div", {
        className: "".concat(styles.gallery, " ").concat(styles["gallery-1"]),
        children: /*#__PURE__*/ _jsx(Picture, _objectSpread({
        }, props))
    }));
};
var Picture = function(param) {
    var src = param.src, alt = param.alt, title = param.title, _className = param.className, className = _className === void 0 ? "" : _className, width = param.width, height = param.height, _sizes = param.sizes, sizes = _sizes === void 0 ? [
        200,
        576,
        768,
        864,
        1000,
        1400,
        1800
    ] : _sizes, _cover = param.cover, cover = _cover === void 0 ? false : _cover, _loading = param.loading, loading = _loading === void 0 ? "lazy" : _loading;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("picture", {
        className: "".concat((_Picture_module_scss__WEBPACK_IMPORTED_MODULE_2___default().image), " ").concat(className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                type: "image/webp",
                title: title,
                className: "".concat((_Picture_module_scss__WEBPACK_IMPORTED_MODULE_2___default().image), " ").concat(className),
                srcSet: sizes.map(function(s, i) {
                    return "".concat(ImageTransformation(src, {
                        w: sizes[i + (cover ? 2 : 0)] || sizes[sizes.length - 1],
                        f: "webp"
                    }), " ").concat(s, "w");
                }).join(", "),
                sizes: "(min-width: 1400px) 100vw, 170px"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                loading: loading,
                src: src,
                alt: alt,
                width: width,
                height: height,
                title: title,
                srcSet: sizes.map(function(s, i) {
                    return "".concat(ImageTransformation(src, {
                        w: sizes[i + (cover ? 2 : 0)] || sizes[sizes.length - 1]
                    }), " ").concat(s, "w");
                }).join(", "),
                sizes: "(min-width: 1400px) 100vw, 170px"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Picture_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: title
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Picture);


/***/ }),

/***/ 7220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _Picture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var _widgets_Price__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6497);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1218);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(209);
/* harmony import */ var _ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9714);
/* harmony import */ var _ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4__);






var ProductCard = function(param) {
    var product = param.product;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().product), " ").concat((_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default())["stock-".concat(product.stock.toLowerCase())]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                href: "/produkt/".concat(product.slug),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Picture__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                        src: (0,_Picture__WEBPACK_IMPORTED_MODULE_1__/* .ImageTransformation */ .dY)(product.thumbnail, {
                            c: "square"
                        }),
                        className: (_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().picture),
                        width: 200,
                        height: 200
                    })
                })
            }),
            product.stock === "LACK" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bg: "danger",
                className: (_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().stockBadge),
                children: "Tymczasowo niedostępny"
            }),
            product.stock === "FEW" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bg: "warning",
                className: (_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().stockBadge),
                children: "Ostatnie sztuki"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_ProductCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default().productName),
                children: product.name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_widgets_Price__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    price: product.price
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCard);


/***/ }),

/***/ 8746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);

var SEO = function(title, description, image) {
    var separator = " :: ";
    var fullTitle = "".concat(Array.isArray(title) ? title.join(separator) : title).concat(separator, "Mellowly");
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:title",
                content: fullTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "og:image",
                content: image
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 7910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var _Picture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2991);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1218);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9296);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5770);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2902);
/* harmony import */ var _Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(959);
/* harmony import */ var _Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var Breadcrumbs = function(param) {
    var parts = param.parts, title = param.title, description = param.description, _background = param.background, background = _background === void 0 ? null : _background;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("nav", {
        className: "".concat((_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().breadcrumbs), " mb-4 ").concat(background ? (_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().hasImage) : ""),
        children: [
            background && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Picture__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                src: background,
                className: (_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().background),
                cover: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: (_Breadcrumbs_module_scss__WEBPACK_IMPORTED_MODULE_3___default().content),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                    href: "/",
                                    children: "Home"
                                })
                            }),
                            parts === null || parts === void 0 ? void 0 : parts.map(function(x) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                        href: x.href,
                                        children: x.name
                                    })
                                }, x.href);
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            xs: 12,
                            sm: 6,
                            children: [
                                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: description
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 6497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);

var Price = function(param) {
    var price = param.price;
    var isSale = price.regular !== price.price;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            isSale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("del", {
                        children: [
                            price.regular,
                            " zł"
                        ]
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                children: [
                    price.price,
                    " zł"
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Price);


/***/ }),

/***/ 9688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6814);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1218);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9296);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5770);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2902);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1301);
/* harmony import */ var _components_ProductCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7220);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8746);
/* harmony import */ var _components_layout_Breadcrumbs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7910);
/* harmony import */ var _styles_shop_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8757);
/* harmony import */ var _styles_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_shop_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var Products = function(param) {
    var products = param.products, category = param.category, categoryPath = param.categoryPath, categoryChildren = param.categoryChildren;
    var buildUrl = function(params) {
        var url = "/sklep";
        if (category) {
            url += "/".concat(category.slug);
        }
        if (params.category) {
            url += "/".concat(params.category.slug);
        }
        return url;
    };
    var parts = categoryPath.reduce(function(p, c) {
        p.path.push({
            href: "".concat(p.lastPart, "/").concat(c.slug),
            name: c.name
        });
        p.lastPart += "/" + c.slug;
        return p;
    }, {
        path: [],
        lastPart: "/sklep"
    }).path;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_1__["default"], {
                children: (0,_components_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)([
                    category.name,
                    "sklep"
                ])
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_layout_Breadcrumbs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                parts: parts,
                background: category.image,
                title: category.name,
                description: category.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                fluid: true,
                className: (_styles_shop_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            children: categoryChildren.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Toggle */ .Z.Toggle, {
                                        variant: "primary",
                                        children: "Kolekcje"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Menu */ .Z.Menu, {
                                        variant: "dark",
                                        children: categoryChildren.map(function(x) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                                                href: buildUrl({
                                                    category: x
                                                }),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"].Item */ .Z.Item, {
                                                    children: x.name
                                                })
                                            }, x.categoryId);
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            md: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: products.map(function(x) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        product: x
                                    }, x.id);
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Products);


/***/ }),

/***/ 6093:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"Picture_image__Gl3E8","gallery":"Picture_gallery__Sr5Bi","gallery-2":"Picture_gallery-2__ZTtaP","gallery-4":"Picture_gallery-4__0rdHj","gallery-6":"Picture_gallery-6__8QkFP","gallery-3":"Picture_gallery-3__NnYQ2","gallery-5":"Picture_gallery-5__iPO4h","title":"Picture_title__pB701"};

/***/ }),

/***/ 9714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"product":"ProductCard_product__33qii","productName":"ProductCard_productName__o_e_a","label":"ProductCard_label__7RGXh","linkBox":"ProductCard_linkBox__1UlJT","link":"ProductCard_link__nff5i","priceBox":"ProductCard_priceBox__U7vaf","price":"ProductCard_price__7TxEl","picture":"ProductCard_picture__jBPwh","stock-lack":"ProductCard_stock-lack__Q3nqA","stockBadge":"ProductCard_stockBadge__f_S4I"};

/***/ }),

/***/ 959:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__gAIss","hasImage":"Breadcrumbs_hasImage__BPPv4","content":"Breadcrumbs_content__9pWF2","background":"Breadcrumbs_background__rLC9U"};

/***/ }),

/***/ 8757:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"shop_container__0GOxv"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [252,98,774,888,179], function() { return __webpack_exec__(9828); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);